import React from 'react';

const Phase0Tab = ({ player }) => {
  return (
    <div className="guess-section">
      <h3 className="guess-section-title">Gæt Vinderen</h3>
      {player.preseasonWinner ? (
        <div className="guess-content">
          <p className="guess-item">
            <strong>Gættet vinder: </strong> {player.preseasonWinner}
          </p>
          <p className="guess-points">
            Point: {player.phase0Points || 0}
          </p>
        </div>
      ) : (
        <p className="no-guess">Ikke gættet endnu</p>
      )}
    </div>
  );
};

export default Phase0Tab;

